/**
 * LoadingBar is a custom HTMLElement that provides loading indicators for theme-wide actions.
 * It responds to custom events ('theme:loading:start', 'theme:loading:end', 'theme:loading:cancel')
 * to trigger loading, stop loading, or cancel loading animations.
 */
class LoadingBar extends window.HTMLElement {
  constructor() {
    super()
    this.attachListeners()
  }

  /**
   * Start the loading animation by adding the 'loading' class.
   */
  startLoading() {
    this.classList.add('loading')
  }

  /**
   * Stop the loading animation by removing the 'loading' class and adding the 'loaded' class.
   * After a short delay, remove the 'loaded' class as well.
   */
  stopLoading() {
    this.classList.remove('loading')
    this.classList.add('loaded')

    setTimeout(() => {
      this.classList.remove('loaded')
    }, 500)
  }

  /**
   * Cancel the loading animation by removing both the 'loading' and 'loaded' classes.
   */
  cancelLoading() {
    this.classList.remove('loading')
    this.classList.remove('loaded')
  }

  /**
   * Attach event listeners to respond to theme-wide loading events.
   */
  attachListeners() {
    document.addEventListener(
      'theme:loading:start',
      this.startLoading.bind(this)
    )
    document.addEventListener('theme:loading:end', this.stopLoading.bind(this))
    document.addEventListener(
      'theme:loading:cancel',
      this.cancelLoading.bind(this)
    )
  }
}

// Register the custom element 'loading-bar'
window.customElements.define('loading-bar', LoadingBar)
